import React, { useMemo } from 'react';
import ProBadge from '../../../assets/shared/ic-shared-pro-badge.svg';
import BasicBadge from '../../../assets/shared/ic-shared-basic-badge.svg';
import SmartBadge from '../../../assets/shared/ic-shared-smart-badge.svg';
import PremiumBadge from '../../../assets/shared/ic-shared-premium-badge.svg';
import CoreBadge from '../../../assets/shared/ic-shared-core-badge.svg';

export enum LiliPlanType {
  BASIC_V2 = 'BASIC_V2',
  CORE = 'CORE',
  PRO_V2 = 'PRO_V2',
  PRO = 'PRO',
  SMART = 'SMART',
  PREMIUM = 'PREMIUM',
}

export interface LiliPlanBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  planType: LiliPlanType;
}

export const LiliPlanBadge = ({ planType, ...rest }: LiliPlanBadgeProps) => {
  const asset = useMemo(() => {
    switch (planType) {
      case LiliPlanType.BASIC_V2:
        return BasicBadge;
      case LiliPlanType.CORE:
        return CoreBadge;
      case LiliPlanType.PRO:
        return ProBadge;
      case LiliPlanType.PRO_V2:
        return ProBadge;
      case LiliPlanType.SMART:
        return SmartBadge;
      case LiliPlanType.PREMIUM:
        return PremiumBadge;
      default:
        return BasicBadge;
    }
  }, [planType]);

  return (
    <div {...rest}>
      {asset && <img id={`profileProBadge-${planType}`} alt='profileProBadge' src={asset} />}
    </div>
  );
};
